import { useTranslation } from 'react-i18next';
import {
  type AmbulanceDriverTypes,
  StatusAmbulanceDriver,
} from '@/domains/traffic-monitoring/constants/listEvent.constant';
import { cn } from '@/lib/utils';
import { useColorStore } from '@/store/colorStore';

interface AmbulanceCardProps {
  platNumber: string;
  ambulanceDriverTypes: AmbulanceDriverTypes;
  address: string;
  onClick?: () => void;
}

// cm_language tags for StatusAmbulanceDriver - the constant only carries color
// plus an English fallback label, so the wording is registered in
// System Management > Language instead.
const STATUS_TAGS: Record<AmbulanceDriverTypes, string> = {
  ongoing: 'psc>ambulance>on-going',
  standby: 'psc>ambulance>standby',
  maintenance: 'psc>ambulance>maintenance',
  offline: 'psc>ambulance>offline',
  // This card is only used by the fleet-monitoring panel, which maps
  // AMB_ST_REQ to 'standby' on purpose (see usePscDashboard.ts) - kept here
  // only so the shared AmbulanceDriverTypes union stays exhaustive.
  requested: 'psc>ambulance>requested',
};

const AmbulanceCard = ({
  ambulanceDriverTypes,
  platNumber,
  address,
  onClick,
}: AmbulanceCardProps) => {
  const { t } = useTranslation();
  const { NEWCOLOR } = useColorStore();
  const getAmbulanceDriver = StatusAmbulanceDriver[ambulanceDriverTypes];
  const statusLabel = STATUS_TAGS[ambulanceDriverTypes]
    ? t(STATUS_TAGS[ambulanceDriverTypes])
    : getAmbulanceDriver.label;

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'w-full hover:border-bg-grey-500 dark:hover:border-bg-grey-400 flex flex-col items-start gap-3 bg-db-card dark:bg-[#F3F6FE]/10  border shadow-[0_4px_4px_0_rgba(0,0,0,0.16)]  p-3 rounded-[12px] cursor-pointer'
      )}
    >
      <div className="w-full flex flex-row gap-3 items-center justify-between">
        <span className="text-db-text dark:text-white   title1medium py-1 px-2 border rounded-[4px] dark:bg-[#F3F6FE]/10 bg-[#F3F6FE] ">
          {platNumber}
        </span>
        <div className="inline-flex gap-2 items-center text-right">
          <span
            className="w-2 h-2 rounded-full"
            style={{ backgroundColor: NEWCOLOR[getAmbulanceDriver.color] }}
          />
          <span
            style={{ color: NEWCOLOR[getAmbulanceDriver.color] }}
            className="text-db-text  title2medium uppercase"
          >
            {statusLabel}
          </span>
        </div>
      </div>
      <span className="title2 text-db-text text-left">{address}</span>
    </button>
  );
};

export default AmbulanceCard;
